import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form, getIn } from 'formik';
import TextInput from 'components/inputs/Input';
import { MdClose } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { FETCH_REPORT_KEY_LIST, CREATE_REPORT_DOWNLOAD_REQUEST, FETCH_TENANTS_LIST } from 'actions/downloadAdvanceReport';
import { useTranslation } from 'react-i18next';
import Button from 'components/inputs/Button';
import * as _ from 'lodash';
import Select from 'components/inputs/Select';
import { toast } from 'react-toastify';

const DownloadChargerStatusReportForm = ({ onClose = _.noop(), downloadReport = _.noop() }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const AdvanceReportSchema = Yup.object().shape({
    name: Yup.string().required(t('downloadReportForm.name')),
  });

  const reportKey = useSelector((state) => state?.reportList?.reportKeys);
  const tenantList = useSelector((state) => state?.reportDownloadRequest?.tenants);

  const tenantTypes = [
    { label: 'B2B', value: 'b2b' },
    { label: 'B2C', value: 'b2c' },
    { label: 'Hybrid', value: 'hybrid' },
    { label: 'SaaS', value: 'SaaS' },
  ];

  const fetchReportList = useCallback((data) => {
    dispatch({
      type: FETCH_REPORT_KEY_LIST.REQUEST,
      payload: { ...data, key: 'chargerStatusReport' },
    });
  }, [reportKey]);

  const fetchTenantsList = useCallback((data) => {
    dispatch({
      type: FETCH_TENANTS_LIST.REQUEST,
      payload: data,
    });
  }, []);

  const initialValues = {
    name: '',
    type: '',
    filter: {
      tenant_type: [],
      tenant_name: [],
    },
  };

  const createReportDownloadRequest = useCallback((data) => {
    dispatch({
      type: CREATE_REPORT_DOWNLOAD_REQUEST.REQUEST,
      payload: data,
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            toast.success('Generated excel Successfully');
            setTimeout(() => {
              downloadReport({ reportId: reportKey?.id });
            }, 500);
          }
        }
      },
    });
  }, [reportKey]);

  useEffect(() => {
    fetchReportList();
  }, []);

  return (
    <React.Fragment>
      <div className="advance-report-form-page__main">
        <Card>
          <div className="advance-report-form-header__block">
            &nbsp;
            <div className="advance-report-header-name">
              <div className="advance-report-form-text-align">{t('downloadReportForm.title')}</div>
            </div>
            <div className="advance-close-btn">
              <MdClose size={30} color="#be210b" onClick={onClose} />
            </div>
            &nbsp;
          </div>
          <div className="advance-report-form-body__block">
            <div className="advance-report-form--block">
              <Formik
                initialValues={initialValues}
                validationSchema={AdvanceReportSchema}
                onSubmit={(values, { setSubmitting }) => {
                  const reportData = {
                    ...values,
                    type: reportKey?.id,
                    filter: {
                      ...values.filter,
                    },
                  };
                  setTimeout(() => {
                    createReportDownloadRequest(reportData);
                    setSubmitting(false);
                    onClose();
                  }, [500]);
                }}
              >
                {({ values, handleSubmit, setFieldValue, handleChange, errors, touched }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col lg={12}>
                        <TextInput
                          isRequired
                          label={t('downloadReportForm.reportName')}
                          placeholder={t('downloadReportForm.enterName')}
                          name="name"
                          value={values.name}
                          onChange={handleChange}
                          error={getIn(errors, 'name') && getIn(touched, 'name') ? getIn(errors, 'name') : null}
                        />
                      </Col>
                      {
                        <Col lg={6}>
                          <Select
                            label="Tenant Type"
                            options={
                              !_.isEmpty(tenantTypes) && [
                                ..._.map(tenantTypes, (item) => {
                                  return { label: item.label, value: item.value };
                                }),
                              ]
                            }
                            placeholder="Tenant Type"
                            name="tenant_type"
                            isMulti
                            value={values.filter.tenant_type}
                            onMenuScrollDown={true}
                            onChange={(val) => {
                              fetchTenantsList({ tenant_type: val });
                              setFieldValue('filter.tenant_type', val);
                            }}
                          />
                        </Col>
                      }
                      {
                        <Col lg={6}>
                          <Select
                            label="Tenant Name"
                            options={
                            Array.isArray(tenantList) && tenantList.length > 0
                              ? tenantList.map((item) => ({
                                  label: item.label || item.name || item.company_name || 'Unknown',
                                  value: item.id || item.value || item._id,
                                }))
                              : []
                          }
                            placeholder="Tenant Name"
                            name="tenant_name"
                            isMulti
                            value={values.filter.tenant_name}
                            onMenuScrollDown={true}
                            onChange={(val) => {
                              setFieldValue('filter.tenant_name', val);
                            }}
                          />
                        </Col>
                      }
                    </Row>
                    <div className="advance-report-input-box__block">
                      <Row>
                        <Col lg={6}>
                          <Button className="advance--btn cancel--btn" onClick={onClose}>
                            {t('button.cancel')}
                          </Button>
                        </Col>
                        <Col lg={6}>
                          <Button type="submit" className="advance--btn  remove--btn" onClick={handleSubmit}>
                            {t('downloadReportForm.button')}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
DownloadChargerStatusReportForm.propTypes = {
  onClose: PropTypes.func,
  downloadReport: PropTypes.func,
};
export default DownloadChargerStatusReportForm;
